import React from "react";
import { DatePicker, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 加载dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

const { RangePicker } = DatePicker;

/**
 * UTC日期范围选择器组件
 * 强制以UTC时区显示和处理日期范围
 * 无论用户当前系统时区如何，输入和输出都是UTC时区
 */
const UTCDateRangePicker = ({ value, onChange, format = "YYYY-MM-DD", style, placeholder, disabled, ...restProps }) => {
    // 将value转换为UTC dayjs对象数组
    const utcValue = value
        ? value.map((date) => {
              if (!date) return null;
              return dayjs.utc(date);
          })
        : [];

    // 处理日期范围变更
    const handleChange = (dates, dateStrings) => {
        // 如果dates为null，直接传递给外部onChange
        if (!dates || dates.length === 0) {
            onChange && onChange(null, []);
            return;
        }

        // 强制将选择的日期解释为UTC时区
        const utcDates = dates.map((date) => {
            if (!date) return null;

            // 提取年月日
            const year = date.year();
            const month = date.month();
            const day = date.date();

            // 使用这些值创建真正的UTC日期（不带时区偏移）
            return dayjs.utc().year(year).month(month).date(day).hour(0).minute(0).second(0).millisecond(0);
        });

        // 生成日期字符串
        const utcDateStrings = utcDates.map((date) => (date ? date.format(format) : ""));

        // 调用外部onChange，传递UTC日期
        onChange && onChange(utcDates, utcDateStrings);
    };

    // 预设日期范围
    const presets = [
        {
            label: "本周",
            value: () => [dayjs.utc().startOf("week"), dayjs.utc().endOf("week")],
        },
        {
            label: "本月",
            value: () => [dayjs.utc().startOf("month"), dayjs.utc().endOf("month")],
        },
        {
            label: "下个月",
            value: () => [dayjs.utc().add(1, "month").startOf("month"), dayjs.utc().add(1, "month").endOf("month")],
        },
        {
            label: "未来14天",
            value: () => [dayjs.utc(), dayjs.utc().add(13, "d")],
        },
        {
            label: "未来30天",
            value: () => [
                dayjs.utc(),
                dayjs.utc().add(29, "d"), // 包含今天在内的未来30天
            ],
        },
    ];

    return (
        <Tooltip title="此日期范围以UTC时区解释">
            <RangePicker value={utcValue.length === 2 ? utcValue : undefined} onChange={handleChange} format={format} style={{ width: "100%", ...style }} placeholder={placeholder ? placeholder : ["开始日期(UTC)", "结束日期(UTC)"]} disabled={disabled} suffixIcon={<GlobalOutlined style={{ color: "#1890ff" }} />} allowClear presets={presets} {...restProps} />
        </Tooltip>
    );
};

export default UTCDateRangePicker;
